import PublicMember from '@/components/PublicMember';

export default PublicMember;
